import { useEffect, useState, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import TkStepper from "../../components/atoms/TkStepper";
import { stepper, fakeTableList } from "./parts";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import TkButton from "../../components/atoms/TkButton";
import _ from "lodash";
import { httpAPI_PRE015 } from "./api/request";
import "./_style.scss";

/**
 * SCRW110004 紙法人の掛金納付対象職員届の登録
 * @return SCRW110004 紙法人の掛金納付対象職員届の登録
 */
const SCRW110004 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [statecorpInfoList, setStatecorpInfoList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const fSkpeer = false;

  const handleInit = async () => {
    // 掛金納付対象職員届提出についての申請状態取得API 呼び出し
    try {
      const res = await httpAPI_PRE015({
        contractorNo: businessState.common?.contractorNo,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        let tableArr = stateFakeTableList.current;
        tableArr.find((item) => item.keyword === "numberOfStaff")!.disabled =
          res.confirmFourActivityFlg !== "1";
        setStatecorpInfoList([...tableArr]);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch {
      navigate("/error");
    }
  };

  // 初期表示
  useEffect(() => {
    setBusinessState({
      ...businessState,
      common: {
        ...businessState.common,
        businessType: "JOB-11",
      },
    });

    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNavigate = (path: any, businessType?: any) => {
    if (businessType) {
      setBusinessState({
        ...businessState,
        common: {
          ...businessState.common,
          businessType,
        },
      });
    }

    navigate(path);
  };

  // 初期表示
  useEffect(() => {
    let tableArr = stateFakeTableList.current;

    tableArr.forEach((item) => {
      if (item.keyword === "contractorName") {
        item.contractorNumber = `${businessState.common?.contractorNo}:${businessState.common?.contractorName}`;
      }

      if (item.buttonName) {
        item.node = (
          <TkButton
            disabled={item.disabled}
            onClick={() => handleNavigate(item.path, item.businessType)}
          >
            {item.buttonName}
          </TkButton>
        );
      }
    });

    setStatecorpInfoList([...tableArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return (
    <Box className="SCRW110004" data-testid="SCRW110004PageForTest">
      {fSkpeer && <TkStepper steps={stepper} activeStep={2} />}

      <TkFakeTable
        list={statecorpInfoList}
        ruleSchema={{}}
        buttonGroup={<TkBackButton />}
        submitButtonText="登録・完了更新"
        onCheckAndSubmit={() => navigate("/SCRC080103")}
      />
    </Box>
  );
};

export default SCRW110004;
